module.exports = require("core-js/library/fn/object/get-prototype-of");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/core-js/object/get-prototype-of.js
// module id = 12
// module chunks = 0 1